import { useState, useEffect } from 'react';

export default function VocabFlashCard({ article, onClose }) {
  const [cards, setCards] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isFlipped, setIsFlipped] = useState(false);
  const [showResult, setShowResult] = useState(false);
  const [correctCount, setCorrectCount] = useState(0);
  const [answeredCount, setAnsweredCount] = useState(0);

  useEffect(() => {
    // 收集所有段落的词汇
    const allVocab = [];
    article?.paragraphs?.forEach((para, paraIndex) => {
      para.vocab?.forEach(vocab => {
        allVocab.push({
          ...vocab,
          paragraphIndex: paraIndex
        });
      });
    });
    // 随机打乱顺序
    setCards(allVocab.sort(() => Math.random() - 0.5));
  }, [article]);

  const currentCard = cards[currentIndex];

  const handleFlip = () => {
    setIsFlipped(!isFlipped);
  };

  const handleNext = () => {
    if (currentIndex < cards.length - 1) {
      setCurrentIndex(currentIndex + 1);
      setIsFlipped(false);
    } else {
      setShowResult(true);
    }
  };

  const handlePrev = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
      setIsFlipped(false);
    }
  };

  const handleKnow = () => {
    setCorrectCount(correctCount + 1);
    setAnsweredCount(answeredCount + 1);
    handleNext();
  };

  const handleDontKnow = () => {
    setAnsweredCount(answeredCount + 1);
    handleNext();
  };

  const handleRestart = () => {
    setCurrentIndex(0);
    setIsFlipped(false);
    setShowResult(false);
    setCorrectCount(0);
    setAnsweredCount(0);
    setCards(cards.sort(() => Math.random() - 0.5));
  };

  if (cards.length === 0) {
    return (
      <div className="flashcard-container">
        <div className="flashcard-modal">
          <div className="flashcard-header">
            <h2>📚 词汇闪卡</h2>
            <button className="btn btn-outline btn-sm" onClick={onClose}>关闭</button>
          </div>
          <div className="empty-state">
            <p>该文章暂无词汇数据</p>
          </div>
        </div>
      </div>
    );
  }

  if (showResult) {
    const accuracy = Math.round((correctCount / answeredCount) * 100);
    return (
      <div className="flashcard-container">
        <div className="flashcard-modal">
          <div className="flashcard-header">
            <h2>🎉 学习完成！</h2>
          </div>
          <div className="result-content">
            <div className="result-stats">
              <div className="stat-item">
                <span className="stat-value">{correctCount}</span>
                <span className="stat-label">已掌握</span>
              </div>
              <div className="stat-item">
                <span className="stat-value">{answeredCount - correctCount}</span>
                <span className="stat-label">需复习</span>
              </div>
              <div className="stat-item">
                <span className="stat-value">{accuracy}%</span>
                <span className="stat-label">正确率</span>
              </div>
            </div>
            <div className="result-message">
              {accuracy >= 80 ? '🌟 太棒了！继续保持！' :
               accuracy >= 60 ? '👍 不错！还有提升空间！' :
               '💪 加油！多复习几遍！'}
            </div>
            <div className="result-actions">
              <button className="btn btn-primary" onClick={handleRestart}>🔄 再来一遍</button>
              <button className="btn btn-outline" onClick={onClose}>关闭</button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="flashcard-container">
      <div className="flashcard-modal">
        <div className="flashcard-header">
          <h2>📚 词汇闪卡</h2>
          <div className="progress-info">
            <span>{currentIndex + 1} / {cards.length}</span>
          </div>
          <button className="btn btn-outline btn-sm" onClick={onClose}>关闭</button>
        </div>
        
        <div className="flashcard-content">
          <div 
            className={`flashcard ${isFlipped ? 'flipped' : ''}`}
            onClick={handleFlip}
          >
            {/* 正面 - 英文 */}
            <div className="flashcard-front">
              <div className="card-word">
                <span className="word-text">{currentCard.word}</span>
                <span className="word-pos">{currentCard.pos}</span>
              </div>
              <div className="card-definition">
                <span className="definition-label">英文释义：</span>
                <p>{currentCard.meaning_en}</p>
              </div>
              <div className="flip-hint">点击翻转查看释义</div>
            </div>
            
            {/* 反面 - 中文 */}
            <div className="flashcard-back">
              <div className="card-meaning">
                <span className="meaning-label">中文释义：</span>
                <p>{currentCard.meaning_cn}</p>
              </div>
              <div className="card-analysis">
                <span className="analysis-label">难度：</span>
                <span className={`difficulty-tag ${currentCard.level.toLowerCase()}`}>
                  {currentCard.level}
                </span>
              </div>
            </div>
          </div>
          
          <div className="flashcard-actions">
            <button 
              className="btn btn-outline" 
              onClick={handlePrev}
              disabled={currentIndex === 0}
            >
              ← 上一个
            </button>
            <button 
              className="btn btn-success" 
              onClick={handleKnow}
            >
              ✅ 认识
            </button>
            <button 
              className="btn btn-danger" 
              onClick={handleDontKnow}
            >
              ❌ 不认识
            </button>
            <button 
              className="btn btn-outline" 
              onClick={handleNext}
              disabled={currentIndex === cards.length - 1}
            >
              下一个 →
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
